import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faEye,
	faEyeSlash,
	faLock,
	faLockOpen,
	faPersonChalkboard,
	faPhone,
	faBan,
} from "@fortawesome/free-solid-svg-icons";
import './ModuleSettings.scss';

const COLOUR_TRUE = "#26A748";
const COLOUR_FALSE = "#F68B1F";

const ModuleSettings = ({
	active,
	onChangeActive,
	lockedLearningJourney,
	onChangeLockedLearningJourney,
	showGuru,
	onChangeShowGuru,
	deviceTraining,
	onChangeDeviceTraining,
}) => {
	const handleKeyToggle = (toggleFn) => (keyboardEvent) => {
		if (!toggleFn) {
			return;
		}
		const { key } = keyboardEvent;
		if (key === "Enter" || key === " ") {
			keyboardEvent.preventDefault();
			toggleFn();
		}
	};

	const SettingItem = ({
		id,
		title,
		isOn,
		onToggle,
		trueIcon,
		falseIcon,
		useBanOverlay = false,
		overlayBaseIcon = null,
	}) => {
		const color = isOn ? COLOUR_TRUE : COLOUR_FALSE;

		return (
			<div
				className="module-settings-item clickable"
				role="checkbox"
				aria-checked={isOn}
				tabIndex={0}
				onClick={onToggle}
				onKeyDown={handleKeyToggle(onToggle)}
			>
				{/* Icon */}
				<span className="module-settings-item-icon">
					{useBanOverlay && !isOn ? (
						<span className="module-settings-item-icon-stack">
							{/* Base icon behind */}
							<FontAwesomeIcon
								icon={overlayBaseIcon}
								className="module-settings-item-icon-stack-base"
								style={{ color }}
							/>
							{/* Ban overlay on top */}
							<FontAwesomeIcon
								icon={faBan}
								className="module-settings-item-icon-stack-ban"
								style={{ color }}
							/>
						</span>
					) : (
						<FontAwesomeIcon icon={isOn ? trueIcon : falseIcon} style={{ color }} />
					)}
				</span>

				{/* Title */}
				<p className="module-settings-item-title">{title}</p>

				<input
					id={id}
					type="checkbox"
					checked={isOn}
					onChange={onToggle}
					onClick={(mouseEvent) => mouseEvent.stopPropagation()}
					className="module-settings-item-checkbox"
				/>
			</div>
		);
	};

	return (
		<div className="module-settings">
			<SettingItem
				id="ms-active"
				title="Active"
				isOn={active}
				onToggle={onChangeActive}
				trueIcon={faEye}
				falseIcon={faEyeSlash}
			/>

			<SettingItem
				id="ms-locked"
				title="Locked Learning Journey"
				isOn={lockedLearningJourney}
				onToggle={onChangeLockedLearningJourney}
				trueIcon={faLock}
				falseIcon={faLockOpen}
			/>

			<SettingItem
				id="ms-guru"
				title="Show Guru"
				isOn={showGuru}
				onToggle={onChangeShowGuru}
				trueIcon={faPersonChalkboard}
				falseIcon={faPersonChalkboard} 
				useBanOverlay
				overlayBaseIcon={faPersonChalkboard}
			/>

			<SettingItem
				id="ms-device"
				title="Device Training"
				isOn={deviceTraining}
				onToggle={onChangeDeviceTraining}
				trueIcon={faPhone}
				falseIcon={faPhone}
				useBanOverlay
				overlayBaseIcon={faPhone}
			/>
		</div>
	);
};

export default ModuleSettings;
